import React, {useState, useEffect} from 'react';
import CenteredSpinner from '../../libs/react-components-admin/spinners/centered-spinner';
import FeedbackForm from '../../libs/react-components-admin/feedback/feedback-form';
import {orgId, defaultErrorHandler} from '../../context/context';
import feedbackV1Client from '../../infrastructure/acerill/feedback-v1-client';
import subscriptionService from '../../services/subscription-service';
import Section from '../../libs/react-components-admin/section/section';

const ViewState = {
  initial: 'initial',
  submitted: 'submitted',
};

const GetInTouch = () => {

  const [viewState, setViewState] = useState(ViewState.initial);
  const [subscriptionPlanCode, setSubscriptionPlanCode] = useState();

  useEffect(() => {
    subscriptionService.findCurrentSubscription()
      .then(subscription => setSubscriptionPlanCode(subscription.planCode))
      .catch(defaultErrorHandler);
  }, []);

  const submitFeedback = (emailAddress, message) =>
    feedbackV1Client
      .submitFeedback(emailAddress, message)
      .then(() => setViewState(ViewState.submitted));

  return <Section title="Get in touch">
    {subscriptionPlanCode == null ?
      <CenteredSpinner/> :
      <div className="row justify-content-center my-4">
        <div className="col-12 col-md-8">
          {subscriptionPlanCode === 'FREE' &&
            <div className="alert alert-warning text-center" role="alert">
              <p className="h5">
                <span className="material-icons align-bottom">warning</span> The free plan does not include any support.
              </p>
              <p>
                You can get access to our support team for only <a href={'/billing/plans?shop=' + orgId}>$2</a>. That said, feedback is always welcome!
              </p>
            </div>
          }
          <FeedbackForm submitAction={(emailAddress, message) => submitFeedback(emailAddress, message)}
                        errorHandler={defaultErrorHandler}
                        disabled={viewState === ViewState.submitted} />
          {viewState === ViewState.submitted &&
          <div className="alert alert-success text-center mt-2" role="alert">
            Thank you, your feedback has been submitted.
          </div>
          }
        </div>
      </div>
    }
  </Section>;
};

export default GetInTouch;
